export default "__VITE_ASSET__BSTCzAJw__"